import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Chalés", href: "#chales" },
  { label: "A Natureza", href: "#manifesto" },
  { label: "Galeria", href: "#galeria" },
  { label: "Reservar", href: "#reservar" },
  { label: "Contato", href: "#contato" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-brand-cream/95 backdrop-blur-md border-b border-brand-forest/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="text-left leading-none"
        >
          <span className={`block text-[11px] tracking-[0.3em] uppercase ${scrolled ? "text-brand-terracotta" : "text-brand-cream/80"}`}>
            Atibaia · SP
          </span>
          <span className={`block text-lg font-bold tracking-tight ${scrolled ? "text-brand-forest" : "text-brand-cream"}`}>
            Recanto dos Pinheiros
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className={`text-[12px] uppercase tracking-[0.2em] font-bold transition-colors ${
                scrolled ? "text-brand-ink hover:text-brand-terracotta" : "text-brand-cream hover:text-brand-terracotta"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? (
            <X className={scrolled ? "text-brand-forest" : "text-brand-cream"} />
          ) : (
            <Menu className={scrolled ? "text-brand-forest" : "text-brand-cream"} />
          )}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden bg-brand-cream border-t border-brand-forest/15 overflow-hidden"
          >
            <div className="flex flex-col px-6 py-4">
              {links.map((l) => (
                <button
                  key={l.href}
                  data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                  onClick={() => go(l.href)}
                  className="py-3 text-left text-sm uppercase tracking-[0.2em] font-bold text-brand-ink border-b border-brand-forest/10 last:border-0"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
